/**
 * Esc clears a bulk selection (Spec 103 E9) — unless someone else owns the key press:
 *   - text entry (inputs that take typed characters, textarea, select, contenteditable);
 *     checkboxes, buttons etc. do not count — the selection itself is made with row checkboxes;
 *   - an open dropdown that closes on Esc: it marks itself with `data-esc-owner` while open;
 *   - focus inside the bulk panel (`data-bulk-panel`), which closes its own editor/menu first.
 */
const NON_TEXT_INPUT_TYPES = new Set([
  'checkbox',
  'radio',
  'button',
  'submit',
  'reset',
  'range',
  'file',
  'color',
]);

export function isSelectionClearKey(event: KeyboardEvent): boolean {
  if (event.key !== 'Escape') return false;
  if (document.querySelector('[data-esc-owner]')) return false;
  const target = event.target;
  if (!(target instanceof HTMLElement)) return true;
  if (target.closest('[data-bulk-panel]')) return false;
  if (target.isContentEditable) return false;
  if (target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) return false;
  if (target instanceof HTMLInputElement) return NON_TEXT_INPUT_TYPES.has(target.type);
  return true;
}
